import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { UserList } from '../../user/models/user-list.model';
import { UserListRecord } from '../../user/models/user-list-record.model';
import { OssUser } from '../models/oss-user';

@Injectable({
  providedIn: 'root'
})
export class BackstrapService {
    private readonly TOKEN_HEADER: string = 'oss-api-token'
    private readonly BASE_URL = environment.API_URL;
    token: string | null = null;

    constructor(private readonly http: HttpClient, private readonly api: ApiService) { 
      let tkn = localStorage.getItem(this.TOKEN_HEADER);
        if(tkn) {
          this.token = tkn;
        }
        else {
          this.token = '';
        }
    }

    private getAuthObj(): any {
      let authObj: any = {};
      if(this.token == null) {
        let tkn = localStorage.getItem(this.TOKEN_HEADER);
        if(tkn) this.token = tkn;
      }
      authObj[this.TOKEN_HEADER] = this.token;
      return authObj;
    }



    async health(): Promise<any> {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.api.get(null, `${this.BASE_URL}/common/internalSystem/health/1.0.0`, {});
          resolve(res);
        }
        catch(err) {
          reject(err);
        }
      });
    }

    // SEE IF A TOKEN IS VALID
    async checkToken(): Promise<boolean> {
      return new Promise(async (resolve, reject) => {
        try {
          await this.api.get(this.getAuthObj(), `${this.BASE_URL}/common/accounts/checkToken/1.0.0`, {});
          resolve(true);
        }
        catch(err) {
          resolve(false);
        }
      });
    }


    async signIn(body: any): Promise<OssUser> {
      return new Promise(async (resolve, reject) => {
        try {
          let res: OssUser = await this.api.post(null, `${this.BASE_URL}/oss/accounts/signIn/1.0.0`, {}, body);
          if(res['oss-api-token'] != null) this.token = res['oss-api-token'];
          localStorage.setItem('oss-api-token', res['oss-api-token']);
          resolve(res);
        }
        catch(err) {
          reject(err);
        }
      });
    }


    async getUsers(): Promise<UserList> {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.api.get(this.getAuthObj(), `${this.BASE_URL}/oss/admin/users/1.0.0`, {});
          resolve(res);
        }
        catch(err) {
          reject(err);
        }
      });
    }

    async searchUsers(searchString: string): Promise<UserList> {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.api.get(this.getAuthObj(), `${this.BASE_URL}/oss/admin/searchUsers/1.0.0?search_string=${searchString}`, {});
          resolve(res);
        }
        catch(err) {
          reject(err);
        }
      });
    }


    async updateUser(userId:string, updObj:any): Promise<void> {
      return new Promise(async (resolve, reject) => {
        try {
          let body = {user_id: userId, user_data: updObj};
          let res = await this.api.patch(this.getAuthObj(), `${this.BASE_URL}/oss/admin/user/1.0.0`, {}, body);
          resolve(res);
        }
        catch(err) {
          reject(err);
        }
      });
    }

    async updatePassword(userId:string, newPw:string): Promise<void> {
      return new Promise(async (resolve, reject) => {
        try {
          let body = {id: userId, password: newPw};
          let res = await this.api.patch(this.getAuthObj(), `${this.BASE_URL}/common/admin/user/1.0.0`, {}, body);
          resolve(res);
        }
        catch(err) {
          reject(err);
        }
      });
    }

    async sendPasswordReset(username:string | null, email:string | null): Promise<void> {
      return new Promise(async (resolve, reject) => {
        try {
          let body: any = {};
          if(username) {
            body['username'] = username;
          }
          else if(email) {
            body['email'] = email;
          }
          else {
            reject('You must provide username or email address to send a password reset link');
            return;
          }

          let res = await this.api.post(this.getAuthObj(), `${this.BASE_URL}/oss/accounts/forgotPassword/1.0.0`, {}, body);
          resolve(res);
        }
        catch(err) {
          reject(err);
        }
      });
    }

    async deleteUser(userId:string): Promise<void> {
      return new Promise(async (resolve, reject) => {
        try {
          let body = {id: userId};
          let res = await this.api.delete(this.getAuthObj(), `${this.BASE_URL}/common/admin/user/1.0.0`, {}, body);
          resolve(res);
        }
        catch(err) {
          reject(err);
        }
      });
    }


    async createUser(usr:UserListRecord, password:string): Promise<void> {
      return new Promise(async (resolve, reject) => {
        try {
          let body = {
            username: usr.username,
            first: usr.first,
            last: usr.last,
            title: usr.title,
            email: usr.email,
            password: password,
            insurance_carrier_id: usr.inscar_ref,
            roles: usr.roles,
            service_location_id: usr.service_location_id
          };
          let res = await this.api.post(this.getAuthObj(), `${this.BASE_URL}/oss/admin/user/1.0.0`, {}, body);
          resolve(res);
        }
        catch(err) {
          reject(err);
        }
      });
    }
}
